export const myDate = (dateString: string, locale: string = 'ro-RO') => {
  const date = new Date(dateString);
  const dayName =
    date.toLocaleString(locale, { weekday: 'long' }).charAt(0).toUpperCase() +
    date.toLocaleString(locale, { weekday: 'long' }).slice(1);
  const monthName =
    date.toLocaleString(locale, { month: 'long' }).charAt(0).toUpperCase() +
    date.toLocaleString(locale, { month: 'long' }).slice(1);
  const year = date.getFullYear();

  return `${dayName}, ${date.getDate()} ${monthName} ${year}`;
};

/**
 * Formats a date as DD-MM-YYYY H:m:s
 * @param date - Date object (defaults to current date if not provided)
 * @returns Formatted date string (e.g., "31-12-2024 14:30:45")
 */
export const formatDateTime = (date: Date = new Date()): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
